module.exports = __webpack_public_path__ + "img/win_tit.6af6f034.png";